export class DialogModelAdnMapConfirm {
    constructor(
      public obj: any
    ) {}
  }
  